export function shouldShowSpeakerLabelOverrides(transcriptUnlockType?: string | null): boolean {
  return transcriptUnlockType === 'ASONE_ENHANCED';
}
